import { isServer } from './is-server'

export const base64Encode = (data: any) => {
  const json = JSON.stringify(data)
  if (!isServer) {
    return window.btoa(json)
  }
  if (isServer) return Buffer.from(json).toString('base64')
}
